(function () {

	'use strict';

	/*global $:true, cologic:true */

	// Generic frontend filter + sort for crawler elements whose items are already rendered
	// server-side as cards (News Crawler: cologic-newsCrawler.js, Event Crawler:
	// EventCrawler.fluid.html). Works purely on the DOM - no re-fetching - and only knows the
	// card's data-* attributes through the config:
	//
	// cologic.initCrawlerControls('#eventCrawler-12', {
	//   card: '.event-card',                       // card selector
	//   filterControl: '.event-crawler-filter',    // all filter <select>/<input> elements
	//   filterAttribute: 'data-crawler-filter',    // attribute holding the filter name on them
	//   sortControl: '.event-crawler-sort',
	//   grid: '.event-crawler-grid',               // grid container (else slider)
	//   slider: '.event-crawler-slider .slider',
	//   sliderViewClass: 'crawler-view-slider',    // root class in slider view
	//   filters: [{
	//     name: 'categories',                      // filterAttribute value
	//     dataKey: 'categories',                   // card data key compared against
	//     match: 'inList' | 'equals' | 'dateFrom' | 'monthFrom',
	//     populate: {                              // optional: fill the <select> from the cards
	//       valueKey: 'categories', labelKey: 'categoryTitles',  // CSV pairs (labelKey optional)
	//       sort: 'locale' | 'plain' | 'value',    // by label (localeCompare / code units) or by value
	//       label: function (value) {}             // optional label formatter (no labelKey)
	//     }
	//   }],
	//   sorts: { date_asc: {dataKey: 'start', type: 'number' | 'string' | 'locale', dir: 'asc'} },
	//   defaultSort: 'date_asc'
	// });

	let cologicCrawlerControls = {

		initCrawlerControls: function (rootSelector, config) {
			let that = this;
			let $root = $(rootSelector);
			if ($root.length <= 0) return;

			this.populateCrawlerFilterOptions($root, config);

			$root.find(config.filterControl).on('change', function () {
				that.applyCrawlerFilters($root, config);
			});

			$root.find(config.sortControl).on('change', function () {
				that.applyCrawlerSort($root, config, $(this).val());
			});

			if ($root.hasClass(config.sliderViewClass)) {
				this.initCrawlerSliderHeight($root, config);
			}
		},

		// iosSlider positions every .slide absolutely (inline style) and then sizes the slider
		// container from its content - which is then 0px tall, since absolute children don't
		// count. Product/Project sliders get around this with a fixed CSS height; card heights
		// here vary (image, teaser length), so the tallest card is measured instead and set as
		// min-height on the track (.slider - iosSlider never touches that property) and on
		// every card, so all cards come out equally tall. Re-measured when images finish
		// loading and on resize (debounced), each time followed by iosSlider's own 'update'.
		initCrawlerSliderHeight: function ($root, config) {
			let that = this;
			let timer = null;
			let schedule = function () {
				clearTimeout(timer);
				timer = setTimeout(function () {
					that.fitCrawlerSliderHeight($root, config);
					that.updateCrawlerSlider($root);
				}, 150);
			};

			this.fitCrawlerSliderHeight($root, config);
			this.updateCrawlerSlider($root);
			$root.find(config.slider + ' img').on('load', schedule);
			$(window).on('load resize', schedule);
		},

		fitCrawlerSliderHeight: function ($root, config) {
			let $track = $root.find(config.slider);
			if ($track.length <= 0) return;
			let $cards = $track.find(config.card);

			$cards.css('min-height', '');
			let maxHeight = 0;
			$cards.each(function () {
				// Hidden by the frontend filter (display: none on the .slide) -> 0, ignored.
				maxHeight = Math.max(maxHeight, $(this).outerHeight(true));
			});
			if (maxHeight <= 0) return;

			$cards.css('min-height', maxHeight + 'px');
			$track.css('min-height', maxHeight + 'px');
		},

		updateCrawlerSlider: function ($root) {
			let elemNr = $root.find('[data-tag-elem-nr]').first().data('tagElemNr');
			if (!elemNr) return;
			try {
				$('#sliderContainer-' + elemNr).iosSlider('update');
			} catch (e) {
				// Slider not initialized (yet) - its own init measures the new height anyway.
			}
		},

		crawlerCsv: function (value) {
			return String(value === undefined || value === null ? '' : value).split(',').filter(function (part) { return part !== ''; });
		},

		crawlerFilterControl: function ($root, config, name) {
			return $root.find('[' + config.filterAttribute + '="' + name + '"]');
		},

		populateCrawlerFilterOptions: function ($root, config) {
			let that = this;
			(config.filters || []).forEach(function (filter) {
				if (!filter.populate) return;
				let populate = filter.populate;
				let labelsByValue = {};

				$root.find(config.card).each(function () {
					let $card = $(this);
					let values = that.crawlerCsv($card.data(populate.valueKey));
					let labels = populate.labelKey ? that.crawlerCsv($card.data(populate.labelKey)) : [];
					values.forEach(function (value, index) {
						value = String(value).trim();
						if (value === '' || typeof labelsByValue[value] !== 'undefined') return;
						labelsByValue[value] = populate.label ? populate.label(value) : (labels[index] || value);
					});
				});

				let values = Object.keys(labelsByValue);
				if (populate.sort === 'value') {
					values.sort();
				} else if (populate.sort === 'plain') {
					values.sort(function (a, b) {
						if (labelsByValue[a] < labelsByValue[b]) return -1;
						if (labelsByValue[a] > labelsByValue[b]) return 1;
						return 0;
					});
				} else {
					values.sort(function (a, b) {
						return String(labelsByValue[a]).localeCompare(String(labelsByValue[b]));
					});
				}

				let $select = that.crawlerFilterControl($root, config, filter.name);
				values.forEach(function (value) {
					$select.append($('<option></option>').attr('value', value).text(labelsByValue[value]));
				});
			});
		},

		applyCrawlerFilters: function ($root, config) {
			let that = this;
			let active = (config.filters || []).map(function (filter) {
				return {filter: filter, value: that.crawlerFilterControl($root, config, filter.name).val()};
			}).filter(function (entry) {
				return entry.value !== undefined && entry.value !== null && entry.value !== '';
			});

			$root.find(config.card).each(function () {
				let $card = $(this);
				let visible = active.every(function (entry) {
					return that.crawlerCardMatches($card, entry.filter, String(entry.value));
				});
				$card.closest('.element-crawler-grid-item, .slide').toggle(visible);
			});

			this.reinitCrawlerSliderIfNeeded($root, config);
		},

		crawlerCardMatches: function ($card, filter, value) {
			let cardValue = $card.data(filter.dataKey);
			switch (filter.match) {
				case 'inList':
					return this.crawlerCsv(cardValue).indexOf(value) !== -1;
				case 'dateFrom': {
					let fromTimestamp = Math.floor(new Date(value + 'T00:00:00').getTime() / 1000);
					if (isNaN(fromTimestamp)) return true;
					return Number(cardValue || 0) >= fromTimestamp;
				}
				case 'monthFrom':
					// "YYYY-MM" strings compare correctly as plain strings.
					return String(cardValue || '') >= value;
				case 'equals':
				default:
					return String(cardValue === undefined || cardValue === null ? '' : cardValue) === value;
			}
		},

		applyCrawlerSort: function ($root, config, order) {
			let sort = (config.sorts || {})[order] || (config.sorts || {})[config.defaultSort];
			if (!sort) return;

			let $grid = $root.find(config.grid);
			let isGrid = $grid.length > 0;
			let $container = isGrid ? $grid : $root.find(config.slider);
			let itemSelector = isGrid ? '.element-crawler-grid-item' : '.slide';
			let factor = sort.dir === 'asc' ? 1 : -1;

			let sortedItems = $container.find(itemSelector).get().sort(function (a, b) {
				let aValue = $(a).find(config.card).data(sort.dataKey);
				let bValue = $(b).find(config.card).data(sort.dataKey);
				if (sort.type === 'number') {
					aValue = Number(aValue) || 0;
					bValue = Number(bValue) || 0;
				} else {
					aValue = String(aValue === undefined || aValue === null ? '' : aValue);
					bValue = String(bValue === undefined || bValue === null ? '' : bValue);
					if (sort.type === 'locale') {
						return aValue.localeCompare(bValue) * factor;
					}
				}
				if (aValue < bValue) return -factor;
				if (aValue > bValue) return factor;
				return 0;
			});

			$.each(sortedItems, function (index, item) {
				$container.append(item);
			});

			this.reinitCrawlerSliderIfNeeded($root, config);
		},

		// iosSlider caches slide positions/count at init time, so any DOM show/hide/reorder in
		// slider view needs the instance torn down and rebuilt - same
		// "#sliderContainer-N"/"#sliderButtonContainer-N"/"#sliderArrowContainer-N" contract
		// cologic.initStdSlider (cologic-slide.js) already uses for Hero/Element Crawler.
		reinitCrawlerSliderIfNeeded: function ($root, config) {
			if (!$root.hasClass(config.sliderViewClass)) return;

			let elemNr = $root.find('[data-tag-elem-nr]').first().data('tagElemNr');
			if (!elemNr) return;

			let sliderId = '#sliderContainer-' + elemNr;
			let $slider = $(sliderId);
			if ($slider.length <= 0) return;

			try {
				$slider.iosSlider('destroy');
			} catch (e) {
				// Not yet initialized, or destroy unsupported on this iosSlider build - safe to ignore.
			}
			// Filtering changes which cards are visible - re-measure before iosSlider sizes itself.
			this.fitCrawlerSliderHeight($root, config);
			cologic.initStdSlider(sliderId, 1, elemNr);
		}

	};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicCrawlerControls);
}());
